// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#navbar-brand {
    font-family: Milonga;
    font-size: 3em;
}

.navbar-logo{
    height: 2em;
}

/* body {
    background: rgb(44, 49, 60) !important;
    background: linear-gradient(270deg, rgba(44, 49, 60, 1) 0%, rgba(0, 0, 0, 1) 100%) !important;
} */

#avatar {
    height: 5.5em;
    width: 5.5em;
    border-radius: 50%;
    padding: 0 !important;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

#tradeUrl-modal-title {
    font-family: 'Milonga', serif;
    font-weight: bold;
    color: white;
    font-size: 2em;
}

#tradeUrl-btn-submit {
    font-family: 'Milonga', serif;
    font-weight: bold;
    color: white;
}



.balance {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
    font-size: 2em !important;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    border-radius: 0.2rem;

}

.login-btn {
    background-color: initial;
    background-image: linear-gradient(rgba(69, 187, 111, 0.84), rgba(41, 119, 64, 0.84) 50%);
    border-radius: 0.3rem;
    justify-content: center;
    text-decoration: none;
    font-size: 2em;
    padding: 0.2em 0.7em 0.2em 0.7em;
}

.login-btn:hover {
    border: 0.1rem solid white;
}

/* .navbar {
    background: rgb(44, 49, 60);
    background: linear-gradient(270deg, rgba(44, 49, 60, 1) 0%, rgba(0, 0, 0, 1) 100%);
} */

.navbar .container {
    min-width: 100% !important;
}

.dropdown-btn {
    padding: 0 !important;
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 50% !important;
}

.dropstart .dropdown-toggle::before {
    display: none !important;
}

.dropdown-menu {
    margin-right: 1rem !important;
    border: 0.1rem solid white !important;
}

#tradeUrlTextArea{
    font-size: 1.5em;
}

#tradeUrlText{
    font-size: 1.2em;
}

#tradeUrl-btn-submit{
    font-size: 1.5em;
}

.tradeurl-setup-complete {
    font-family: 'Milonga', serif;
}

.balance{
    -webkit-user-select: none;
            user-select: none;  /* Prevent image selection */
    -webkit-user-drag: none; /* Prevent dragging in Webkit browsers */
    outline: none; /* Remove blue outline on focus */
}

#navbar-brand{
    -webkit-user-select: none;
            user-select: none;  /* Prevent image selection */
    -webkit-user-drag: none; /* Prevent dragging in Webkit browsers */
    outline: none; /* Remove blue outline on focus */
}

.checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: white;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards
}

.checkmark {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px #9c9c9c;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both
}

.checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0
    }
}

@keyframes scale {

    0%,
    100% {
        transform: none
    }

    50% {
        transform: scale3d(1.1, 1.1, 1)
    }
}

@keyframes fill {
    100% {
        box-shadow: inset 0px 0px 0px 30px #9c9c9c
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Nav.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;;;GAGG;;AAEH;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,uLAAuL;AAC3L;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,YAAY;AAChB;;;;AAIA;IACI,uLAAuL;IACvL,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;;AAEzB;;AAEA;IACI,yBAAyB;IACzB,wFAAwF;IACxF,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;GAGG;;AAEH;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB,GAAG,4BAA4B;IAChD,uBAAuB,EAAE,wCAAwC;IACjE,aAAa,EAAE,iCAAiC;AACpD;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB,GAAG,4BAA4B;IAChD,uBAAuB,EAAE,wCAAwC;IACjE,aAAa,EAAE,iCAAiC;AACpD;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,qCAAqC;IACrC;AACJ;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ","sourcesContent":["#navbar-brand {\n    font-family: Milonga;\n    font-size: 3em;\n}\n\n.navbar-logo{\n    height: 2em;\n}\n\n/* body {\n    background: rgb(44, 49, 60) !important;\n    background: linear-gradient(270deg, rgba(44, 49, 60, 1) 0%, rgba(0, 0, 0, 1) 100%) !important;\n} */\n\n#avatar {\n    height: 5.5em;\n    width: 5.5em;\n    border-radius: 50%;\n    padding: 0 !important;\n    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\n}\n\n#tradeUrl-modal-title {\n    font-family: 'Milonga', serif;\n    font-weight: bold;\n    color: white;\n    font-size: 2em;\n}\n\n#tradeUrl-btn-submit {\n    font-family: 'Milonga', serif;\n    font-weight: bold;\n    color: white;\n}\n\n\n\n.balance {\n    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\n    font-size: 2em !important;\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n    padding-top: 0.2rem;\n    padding-bottom: 0.2rem;\n    border-radius: 0.2rem;\n\n}\n\n.login-btn {\n    background-color: initial;\n    background-image: linear-gradient(rgba(69, 187, 111, 0.84), rgba(41, 119, 64, 0.84) 50%);\n    border-radius: 0.3rem;\n    justify-content: center;\n    text-decoration: none;\n    font-size: 2em;\n    padding: 0.2em 0.7em 0.2em 0.7em;\n}\n\n.login-btn:hover {\n    border: 0.1rem solid white;\n}\n\n/* .navbar {\n    background: rgb(44, 49, 60);\n    background: linear-gradient(270deg, rgba(44, 49, 60, 1) 0%, rgba(0, 0, 0, 1) 100%);\n} */\n\n.navbar .container {\n    min-width: 100% !important;\n}\n\n.dropdown-btn {\n    padding: 0 !important;\n    background-repeat: no-repeat;\n    background-size: contain;\n    border-radius: 50% !important;\n}\n\n.dropstart .dropdown-toggle::before {\n    display: none !important;\n}\n\n.dropdown-menu {\n    margin-right: 1rem !important;\n    border: 0.1rem solid white !important;\n}\n\n#tradeUrlTextArea{\n    font-size: 1.5em;\n}\n\n#tradeUrlText{\n    font-size: 1.2em;\n}\n\n#tradeUrl-btn-submit{\n    font-size: 1.5em;\n}\n\n.tradeurl-setup-complete {\n    font-family: 'Milonga', serif;\n}\n\n.balance{\n    user-select: none;  /* Prevent image selection */\n    -webkit-user-drag: none; /* Prevent dragging in Webkit browsers */\n    outline: none; /* Remove blue outline on focus */\n}\n\n#navbar-brand{\n    user-select: none;  /* Prevent image selection */\n    -webkit-user-drag: none; /* Prevent dragging in Webkit browsers */\n    outline: none; /* Remove blue outline on focus */\n}\n\n.checkmark__circle {\n    stroke-dasharray: 166;\n    stroke-dashoffset: 166;\n    stroke-width: 2;\n    stroke-miterlimit: 10;\n    stroke: white;\n    fill: none;\n    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards\n}\n\n.checkmark {\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    display: block;\n    stroke-width: 2;\n    stroke: #fff;\n    stroke-miterlimit: 10;\n    margin: 10% auto;\n    box-shadow: inset 0px 0px 0px #9c9c9c;\n    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both\n}\n\n.checkmark__check {\n    transform-origin: 50% 50%;\n    stroke-dasharray: 48;\n    stroke-dashoffset: 48;\n    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards\n}\n\n@keyframes stroke {\n    100% {\n        stroke-dashoffset: 0\n    }\n}\n\n@keyframes scale {\n\n    0%,\n    100% {\n        transform: none\n    }\n\n    50% {\n        transform: scale3d(1.1, 1.1, 1)\n    }\n}\n\n@keyframes fill {\n    100% {\n        box-shadow: inset 0px 0px 0px 30px #9c9c9c\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
